import React from 'react'
import { Icon } from '@chakra-ui/react'
const RightArrow = (props) => (
  <Icon viewBox="0 0 39 19" width="39" height="19" {...props}>
    <path
      d="M38.0513 8.32572L30.4065 0.480771C29.9489 0.0113418 29.2609 -0.129063 28.6631 0.12501C28.0653 0.379082 27.6755 0.977614 27.6753 1.64159V6.61323C27.6753 6.83993 27.4962 7.02371 27.2753 7.02371H2.52012C1.19463 7.02371 0.120117 8.12635 0.120117 9.48654C0.120117 10.8467 1.19463 11.9494 2.52012 11.9494H27.2753C27.4962 11.9494 27.6753 12.1332 27.6753 12.3598V17.3315C27.6755 17.9955 28.0653 18.594 28.6631 18.8481C29.2609 19.1021 29.9489 18.9617 30.4065 18.4923L38.0513 10.6474C38.6759 10.0062 38.6759 8.96688 38.0513 8.32572Z"
      fill="currentColor"
    />
  </Icon>
)

export default RightArrow
